import { useLocaleString } from '../../../hooks/useLocale';
import { ShortUser } from './transfer_unit';

export class ShortUserModel implements ShortUser {
  id: number;
  english_name: string;
  arabic_name: string;

  constructor(data: Partial<ShortUser>) {
    this.id = data.id ?? 0;
    this.english_name = data.english_name ?? '';
    this.arabic_name = data.arabic_name ?? '';
  }

  /** from json to class */
  static fromJson(data: any): ShortUserModel {
    return new ShortUserModel(data);
  }

  /** from class to json */
  toJson(): ShortUser {
    return {
      id: this.id,
      english_name: this.english_name,
      arabic_name: this.arabic_name,
    };
  }

  get fullName(): string {
    return useLocaleString(this.arabic_name, this.english_name);
  }
}
